import Component from '../core/Component'
import support from '../utils/BrowserSupport'
import Scroll from '../services/Scroll'
import enquire from 'enquire.js'
import { queries } from '../core/config'

const STATES = {
    COLLAPSED: 'is-collapsed',
    EXPANDED: 'is-expanded',
    SEARCH_ACTIVE: 'is-search-active'
}

export default class ProjectFilter extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            searchToggle: null,
            toggles: [],
            content: null,
            search: null
        }

        this.enquireHandler = {
            match: () => {
                this.ref.search.removeAttribute('style')
            }
        }
    }

    prepare() {
        this.ref.toggles.forEach(element => element.addEventListener('click', this.handleToggleClick))
        this.ref.content.addEventListener(support.transitionEnd, event => {
            if (event.target !== this.ref.content) {
                return
            }

            if (!this.is(STATES.COLLAPSED)) {
                this.element.classList.add(STATES.EXPANDED)
                this.ref.content.removeAttribute('style')
            }
        })
        this.collapse()

        this.ref.searchToggle.addEventListener('click', this.handleSearchToggleClick)

        Scroll.on('resize', this.handleResize)
        enquire.register(queries.smallWideMax, this.enquireHandler)
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
        enquire.unregister(queries.smallWideMax, this.enquireHandler)

    }

    handleResize = () => {
        this.resize()
    }

    handleSearchToggleClick = event => {
        event.preventDefault()
        this.toggleSearch()
    }

    handleToggleClick = event => {
        event.preventDefault()
        this.toggle()
    }

    resize() {
        if (this.is(STATES.SEARCH_ACTIVE)) {
            this.ref.content.style.height = `${this.ref.content.scrollHeight}px`
        }
    }

    toggle() {
        if (this.is(STATES.COLLAPSED)) {
            this.expand()
        } else {
            this.collapse()
        }
    }

    expand() {
        this.element.classList.remove(STATES.COLLAPSED)
        this.ref.content.style.height = `${this.ref.content.scrollHeight}px`
    }

    collapse() {
        this.element.classList.remove(STATES.EXPANDED)
        this.ref.content.style.height = `${this.ref.content.scrollHeight}px`
        this.element.classList.add(STATES.COLLAPSED)
        this.ref.content.offsetWidth
        this.ref.content.style.height = '0px'
    }

    toggleSearch() {
        if (this.is(STATES.SEARCH_ACTIVE)) {
            this.hideSearch()
        } else {
            this.showSearch()
        }
    }

    showSearch() {
        this.element.classList.add(STATES.SEARCH_ACTIVE)
        this.ref.search.style.height = `${this.ref.search.scrollHeight}px`
        this.emit('searchshow')
    }

    hideSearch() {
        this.element.classList.remove(STATES.SEARCH_ACTIVE)
        this.ref.search.style.height = '0px'
        this.emit('searchhide')
    }
}